import { React } from "react";
import Table from "react-bootstrap/Table";

import StatusDisplay from "../StatusDisplay";

import { RiDeleteBin6Line } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import { BsEye } from "react-icons/bs";

import { TableStyle } from "./style";

function TableComponent({ registros }) {
  return (
    <TableStyle>
      <div className="table-area">
        <Table hover striped>
          <thead>
            <tr>
              <th>Registro</th>
              <th>Nome</th>
              <th>Sobrenome</th>
              <th>Email</th>
              <th>Status</th>
              <th colSpan="3">Ações</th>
            </tr>
          </thead>
          <tbody>                       
            {registros.length > 0 ? (
                registros.map((r, i) => {
                  return (
                    <tr key={i}>
                      <td>{r.cod}</td>
                      <td>{r.nome}</td>
                      <td>{r.sobrenome}</td>
                      <td>{r.email}</td>
                      <td>
                        <StatusDisplay status={r.status}/>                    
                      </td>
                      <td className="action-column">
                        <BsEye/>
                      </td>
                      <td className="action-column">
                        <CiEdit />
                      </td>
                      <td className="action-column">
                        <RiDeleteBin6Line id="delete-icon" />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr></tr>
              )}            
          </tbody>
        </Table>
      </div>
    </TableStyle>
  );
}

export default TableComponent;
